import { ChangeDetectorRef,HostListener, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { CtButtonComponent } from '../ct-button/ct-button.component';
import { PfComponents } from '../../enums/pfComponents';
import { ADN_PLUS, Action } from '../../models';
import { breakpoints } from '../../environments/environment.breakpoints';

@Component({
  selector: 'ct-button-uncompressed-container',
  templateUrl: './ct-button-uncompressed-container.component.html',
  styleUrls: ['./ct-button-uncompressed-container.component.css']
})
export class CtButtonUncompressedContainerComponent extends CtrlBaseComponent implements OnInit {

  @ViewChild('buttonContainer', { read: ViewContainerRef }) buttonContainer: ViewContainerRef;

  private title: string;
  private action: Action;
  private action2: Action;
  private adn: ADN_PLUS[] = [];

  //util
  public isMediumSize : boolean = false;
  public isSmallSize : boolean = false;
  public isExtraSmall : boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.manageWindowResizing(window.innerWidth);
     }


  constructor(private cfr: ComponentFactoryResolver, private cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.action = this.getEvent('onClick');
    this.action2 = this.getEvent('onInit');
    this.manageWindowResizing(window.innerWidth);
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.buttonContainer);
    this.manageWindowResizing(window.innerWidth);
}

  private manageWindowResizing(width: number) {
    this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
    this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
    this.isMediumSize = width >= breakpoints.L;
    this.cdr.detectChanges();
  }

  private createComponent(container: ViewContainerRef, componentReference: any, metadata: any) {
    container.clear();
    const componentFactory = this.cfr.resolveComponentFactory(componentReference);
    const componentRef = container.createComponent(componentFactory);
    const component: any = componentRef.instance;
    component.setMetaData(metadata);
    return component;
  }
  
  private createButton(response: ADN_PLUS[]): void {
    const responseComponents: any = this.getResponseComponents(response);

    if (!responseComponents) return;

    this.setDataToContainer(responseComponents);
    this.paintChildren(this.getMetaData(), this.buttonContainer);
  }

  private getResponseComponents(response: ADN_PLUS[]): any[] {
    if (!response) return [];
    
    return response.map((adn, index) => {
      const data = this.getDataFromAdn(adn);

      if (!data.description || !data.descriptionValue || !data.buttonText || !data.tag) {
        return null;
      }

      const ctButtonMetadata = this.getCtButtonMetadata(data, index, adn);

      if (this.action2) {
        this.action2.conditionParams = [ctButtonMetadata.controlProperties.id];
        ctButtonMetadata.controlActions = [{
          "displayName": null,
          "eventName": "onClick",
          "actionKey": null,
          "type": "VIEW",
          "action": "ActionBtnChild",
          "isAsync": false,
          "actionParams": [],
          "conditionParams": [],
          "utilParams": [
            ctButtonMetadata.controlProperties.id,
          ],
          "preAction": null,
          "postAction": null,
          "params": [],
          "actionsFlow": null,
          "OperationType": null,
          "Entity": null,
          "Operation": "ActionBtnChild",
          "Endpoint": null
        }]
      }

      return ctButtonMetadata;
    })
      .filter(metadata => metadata !== null);
  }

  private getDataFromAdn(adn: ADN_PLUS): { buttonColor: string, buttonType: string, icon: string, buttonText: string, tag: string, description: string, descriptionValue: string, tagColor: string} {
    return {
      buttonColor: this.utilService.getStringAttribute('BUTTON_COLOR', adn.ArrayEntities.List),
      buttonType: this.utilService.getStringAttribute('TYPE', adn.ArrayEntities.List),
      icon: this.utilService.getStringAttribute('ICON', adn.ArrayEntities.List),
      buttonText: this.utilService.getStringAttribute('BUTTON_TEXT', adn.ArrayEntities.List),
      tag: this.utilService.getStringAttribute('TAG', adn.ArrayEntities.List),
      description: this.utilService.getStringAttribute('DESCRIPTION', adn.ArrayEntities.List),
      descriptionValue: this.utilService.getStringAttribute('DESCRIPTION_VALUE', adn.ArrayEntities.List),
      tagColor: this.utilService.getStringAttribute('TAG_COLOR', adn.ArrayEntities.List)
    };
  }

  private getCtButtonMetadata(data: any, index: number, adn: ADN_PLUS): any {
    return {
      ctType: PfComponents.CtButton,
      controlProperties: {
        type: data.buttonType,
        tag: data.tag,
        tagColor: data.tagColor,
        description: data.description,
        descriptionValue: data.descriptionValue,
        buttonText: data.buttonText,
        hidden: false,
        listenedComponentId: "",
        listenedProperty: "",
        disabled: false,
        rightToLeft: false,
        id: `${this.getViewId()}_${PfComponents.CtButton}_default_${(this.generarNumeroUnico())*(index+1)}`,
        modelId: "",
        pickId: "",
        buttonColor: data.buttonColor,
        icon: data.icon,
        value: { ...adn } 
      },
      controlActions: this.action != null ? [this.action] : [],
      models: []
    };
  }

  public getAmountChildElements (): number {
    let amountChildElements =  this.getChildElements().length
    if(amountChildElements > 1){
      (this.getChildElements().length)/2
    }

   return amountChildElements
  }
  
  private generarNumeroUnico() {

    let randomNumber = Math.floor(Math.random() * 1000) + 1;
    return randomNumber;
  }

  private setDataToContainer(newButtonChildren: any[]): void {
    this.getMetaData().models = newButtonChildren;
    this.setChildrenToParentContainer();
  }

  private setChildrenToParentContainer(): void {
    if (this.buttonContainer) {
      const childrenInstances = this.getMetaData().models.map((child: any) => {
        const buttonComponentInstance = new CtButtonComponent(this.cdr);
        buttonComponentInstance.setMetaData(child);
        buttonComponentInstance.ngOnInit();
        return buttonComponentInstance;
      });
  
      this.addChildren(childrenInstances);
    }
  }


  // Getters and Setters
  public getTitle(): string { return this.title; }
  public getADN(): ADN_PLUS[] {return this.adn;}
  public setTitle(title: string): void { this.title = title;}
  public setADN(adn: ADN_PLUS[]): void {this.adn = adn; this.createButton(adn);}
}
